// FiltersBar.jsx
import React from "react";
import FilterDropdown from "../dropdowns/filter-dropdown";
import { MaterialMenu, ColorMenu,MaterialMenuTwo,MaterialMenuThree,MaterialMenuFour } from "../dropdowns/menus";
import { SelectedFilters } from "../dropdowns/selected-filters";
import StockAmountMenu from "../dropdowns/stock-amount-menu";

let COLLECTIONS_OPTIONS = [];

let PATTERN_OPTIONS = [];

let STATUS_OPTIONS = [
    { value: "inStock", label: "In Stock" },
    { value: "performance", label: "Performance" },
    { value: "commercialGrade", label: "Commercial Grade" }
];

let COLOR_OPTIONS = [];

let GRADE_OPTIONS = [];



class FabricFiltersBar extends React.Component {
    constructor(props) {
        super(props);

        var init = props.initialFilters || {};
        this.state = {
            // stock is a { stockMin, stockMax } range object (was a
            // checkbox-value array pre-2026-07).
            stock: init.stock || {},
            status: init.status || [],
            collections: init.collections || [],
            patterns: init.patterns || [],
            colors: init.colors || [],
            grades: init.grades || [],
            showMoreFilters: false
        };

        this.populateOptions();
    }

    populateOptions=()=>{
        // Reset module-level OPTIONS arrays before re-populating — without this,
        // a key-bump remount of FabricFiltersBar (triggered by URL-state
        // restoration) re-runs the constructor and APPENDS duplicates.
        COLLECTIONS_OPTIONS = [];
        PATTERN_OPTIONS = [];
        COLOR_OPTIONS = [];
        GRADE_OPTIONS = [];
        var filters=this.props.filters;
        filters.collections.forEach((obj)=>{
            if(obj)COLLECTIONS_OPTIONS.push({value:obj,label:obj});
        });
        filters.patterns.forEach((obj)=>{
            if(obj)PATTERN_OPTIONS.push({value:obj,label:obj});
        });
        filters.colors.forEach((obj)=>{
            if(obj)COLOR_OPTIONS.push({value:obj,label:obj});
        });
        filters.grades.forEach((obj)=>{
            if(obj)GRADE_OPTIONS.push({value:obj,label:obj});
        });

    }

    toggleValueOLD = (group, value) => {
        this.setState((prev) => {
            const current = prev[group] || [];
            const exists = current.indexOf(value) !== -1;
            return {
                ...prev,
                [group]: exists
                    ? current.filter((v) => v !== value)
                    : current.concat(value),
            };
        });
    };

    toggleValue = (group, value) => {
        this.setState((prev) => {
            const current = prev[group] || [];
            const exists = current.indexOf(value) !== -1;

            const updatedGroup = exists
                ? current.filter((v) => v !== value)
                : current.concat(value);

            const nextState = {
                ...prev,
                [group]: updatedGroup,
            };

            if (typeof this.props.onFiltersChange === "function") {
                // pass the full filters object up to the parent
                this.props.onFiltersChange(nextState);
            }

            return nextState;
        });
    };

    clearGroup = (group) => {
        this.setState((prev) => ({ ...prev, [group]: [] }));
    };

    onStockApply = (vals) => {
        this.setState((prev) => {
            var nextState = { ...prev, stock: vals || {} };
            if (typeof this.props.onFiltersChange === "function") {
                this.props.onFiltersChange(nextState);
            }
            return nextState;
        });
    };

    clearAll = () => {
        var cleared = {
            stock: {},
            status: [],
            collections: [],
            patterns: [],
            colors: [],
            grades: []
        };
        this.setState(cleared, () => {
            if (typeof this.props.onClearAll === 'function') {
                this.props.onClearAll(cleared);
            } else if (typeof this.props.onFiltersChange === 'function') {
                this.props.onFiltersChange(cleared);
            }
        });
    };

    getSelectedItems() {
        const { stock, status, collections, patterns, colors, grades } = this.state;
        const chips = [];

        if (stock && (stock.stockMin != null || stock.stockMax != null)) {
            var stockLabel;
            if (stock.stockMin != null && stock.stockMax != null) {
                stockLabel = `${stock.stockMin} – ${stock.stockMax}`;
            } else if (stock.stockMin != null) {
                stockLabel = `${stock.stockMin}+`;
            } else {
                stockLabel = `Up to ${stock.stockMax}`;
            }
            chips.push({
                id: "stock:range",
                group: "stock",
                value: "range",
                label: `Stock Amount: ${stockLabel}`,
            });
        }

        PATTERN_OPTIONS.forEach((opt) => {
            if (patterns.indexOf(opt.value) !== -1) {
                chips.push({
                    id: `pattern:${opt.value}`,
                    group: "patterns",
                    value: opt.value,
                    label: `Pattern: ${opt.label}`,
                });
            }
        });
        
        
        COLOR_OPTIONS.forEach((opt) => {
            if (colors.indexOf(opt.value) !== -1) {
                chips.push({
                    id: `color:${opt.value}`,
                    group: "colors",
                    value: opt.value,
                    label: `Color: ${opt.label}`,
                });
            }
        });

        STATUS_OPTIONS.forEach((opt) => {
            if (status.indexOf(opt.value) !== -1) {
                chips.push({
                    id: `status:${opt.value}`,
                    group: "status",
                    value: opt.value,
                    label: `Status: ${opt.label}`,
                });
            }
        });
        GRADE_OPTIONS.forEach((opt) => {
            if (grades.indexOf(opt.value) !== -1) {
                chips.push({
                    id: `grade:${opt.value}`,
                    group: "grades",
                    value: opt.value,
                    label: `Grade: ${opt.label}`,
                });
            }
        });
        COLLECTIONS_OPTIONS.forEach((opt) => {
            if (collections.indexOf(opt.value) !== -1) {
                chips.push({
                    id: `collection:${opt.value}`,
                    group: "collections",
                    value: opt.value,
                    label: `Collection: ${opt.label}`,
                });
            }
        });
        

        return chips;
    }

    handleRemoveChip = (chip) => {
        if (chip.group === "stock") {
            this.onStockApply({});
            return;
        }
        this.toggleValue(chip.group, chip.value);
    };

    onMoreLessFilters = () => {
        this.setState((prev) => ({
            showMoreFilters: !prev.showMoreFilters
        }));
    }

    render() {
        const { stock, status, collections, patterns, colors, grades } = this.state;
        const chips = this.getSelectedItems();
        let state=this.state;
        let moreLessLabel=state.showMoreFilters?"Less Filters":"More Filters";
        let moreLessSymbol=state.showMoreFilters?"-":"+";
        let moreLessClass=state.showMoreFilters?"ff-filter-minus":"ff-filter-plus";
        let gradesCls='';
        if(GRADE_OPTIONS.length<2) gradesCls='hide';
        let collectionsCls='';
        if(COLLECTIONS_OPTIONS.length<2) collectionsCls='hide';
        
        return (
            <div>
                {/* Top filter bar */}
                <div className="ff-filter-bar">
                    <FilterDropdown label="Patterns">
                        {({ close }) => (
                            <MaterialMenuTwo
                                options={PATTERN_OPTIONS}
                                selectedValues={patterns}
                                onToggle={(value) => this.toggleValue("patterns", value)}
                            />
                        )}
                    </FilterDropdown>
                    <FilterDropdown label="Collections" cls={collectionsCls}>
                        {({ close }) => (
                            <MaterialMenu
                                options={COLLECTIONS_OPTIONS}
                                selectedValues={collections}
                                onToggle={(value) => this.toggleValue("collections", value)}
                            />
                        )}
                    </FilterDropdown>
                    <FilterDropdown label="Status">
                        {({ close }) => (
                            <MaterialMenu
                                options={STATUS_OPTIONS}
                                selectedValues={status}
                                onToggle={(value) => this.toggleValue("status", value)}
                            />
                        )}
                    </FilterDropdown>
                    <FilterDropdown label="Grades" cls={gradesCls}>
                        {({ close }) => (
                            <MaterialMenuFour
                                options={GRADE_OPTIONS}
                                selectedValues={grades}
                                onToggle={(value) => this.toggleValue("grades", value)}
                            />
                        )}
                    </FilterDropdown>
                    <FilterDropdown label="Stock Amount">
                        {({ close }) => (
                            <StockAmountMenu
                                values={stock}
                                onApply={this.onStockApply}
                                close={close}
                            />
                        )}
                    </FilterDropdown>

                    
                    <FilterDropdown label="Colors">
                        {({ close }) => (
                            <MaterialMenu
                                options={COLOR_OPTIONS}
                                selectedValues={colors}
                                onToggle={(value) => this.toggleValue("colors", value)}
                            />
                        )}
                    </FilterDropdown>
                    
                    {state.showMoreFilters && (
                        <>
                            
                        </>
                    )}
                    <div className="ff-more-filters-button hide" onClick={this.onMoreLessFilters}>
                        <span className="ff-more-filters-label">{moreLessLabel}</span><span className={moreLessClass}>{moreLessSymbol}</span>
                    </div>
                   
                </div>

                {/* Selected filters row */}
                <SelectedFilters
                    items={chips}
                    onRemove={this.handleRemoveChip}
                    onClearAll={this.clearAll}
                />
            </div>
        );
    }
}

export default FabricFiltersBar;
